export default "__VITE_ASSET__AUUxz99z__"